module.exports = __webpack_public_path__ + "img/130.need_improved.6751ffbd.svg";